/* Coturn — coming soon.
   Without this file the page still works: the film has native controls and the sign-up posts
   as a normal form, coming back with the thank-you rendered by the server. This file adds the
   teaser loop, the quiet controls, the sign-up without a reload, and the surprise. */
(() => {
  const root = document.querySelector('[data-cs]');
  if (!root) return;

  const $ = (sel) => root.querySelector(sel);
  const film = $('[data-cs-film]');
  const video = $('[data-cs-video]') || $('.cs-film video');
  const toggle = $('[data-cs-toggle]');
  const sound = $('[data-cs-sound]');
  const form = $('[data-cs-form]') || $('.cs-form');
  const input = form && form.querySelector('input[type="email"]');
  const error = $('[data-cs-error]');
  const status = $('[data-cs-status]');
  const idle = $('[data-cs-idle]');
  const done = $('[data-cs-done]');
  const doneTitle = $('[data-cs-done-title]');
  const full = $('[data-cs-full]');
  const copy = $('[data-cs-copy]');

  const label = (key) => root.getAttribute('data-l-' + key) || '';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = !!(navigator.connection && navigator.connection.saveData);
  const mayAutoplay = !reduceMotion.matches && !saveData;

  let teaserEnd = parseFloat(root.getAttribute('data-teaser-end')) || 0;
  let unlocked = root.getAttribute('data-state') === 'done';
  let userPaused = !mayAutoplay; // a reader who asked for less motion starts on the poster
  let cinema = false;
  let inView = true;

  const say = (text) => {
    if (!status) return;
    status.textContent = '';
    window.setTimeout(() => { status.textContent = text; }, 60);
  };

  /* ------------------------------------------------------------ film */

  const syncControls = () => {
    if (!video) return;
    const paused = video.paused;
    root.toggleAttribute('data-paused', paused);
    if (toggle) toggle.setAttribute('aria-label', paused ? label('play') : label('pause'));
    const loud = !video.muted;
    root.toggleAttribute('data-sound', loud);
    if (sound) sound.setAttribute('aria-label', loud ? label('mute') : label('unmute'));
  };

  const play = () => {
    if (!video) return;
    const attempt = video.play();
    if (attempt && attempt.catch) {
      attempt.catch(() => {
        // Sound was refused (no gesture yet): carry on muted rather than not at all.
        if (!video.muted) { video.muted = true; video.play().catch(syncControls); }
        syncControls();
      });
    }
  };

  const exitCinema = () => {
    if (!cinema) return;
    cinema = false;
    root.classList.remove('is-cinema');
    video.muted = true;
    video.loop = true;
    syncControls();
  };

  if (video) {
    video.controls = false;
    video.removeAttribute('controls');
    video.muted = true;
    video.playsInline = true;
    video.loop = unlocked || teaserEnd <= 0;
    if (mayAutoplay) video.preload = 'auto';

    // The teaser: loop the opening part only, and keep the closing lockup for later.
    const keepToTeaser = () => {
      if (!unlocked && teaserEnd > 0 && video.currentTime >= teaserEnd) video.currentTime = 0;
    };
    if ('requestVideoFrameCallback' in HTMLVideoElement.prototype) {
      const onFrame = () => { keepToTeaser(); video.requestVideoFrameCallback(onFrame); };
      video.requestVideoFrameCallback(onFrame);
    } else {
      video.addEventListener('timeupdate', keepToTeaser);
    }

    ['play', 'pause', 'volumechange'].forEach((type) => video.addEventListener(type, syncControls));
    video.addEventListener('ended', () => {
      if (cinema) {
        // The whole film has played: hold its last frame (the lockup) and give the room back.
        cinema = false;
        root.classList.remove('is-cinema');
        video.muted = true;
        video.loop = true;
        userPaused = true;
        syncControls();
      }
    });

    if (toggle) {
      toggle.addEventListener('click', () => {
        if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); }
      });
    }
    if (sound) {
      sound.hidden = !unlocked;
      sound.addEventListener('click', () => {
        video.muted = !video.muted;
        if (!video.muted && video.paused) { userPaused = false; play(); }
        syncControls();
      });
    }

    // Off screen (a phone scrolled down to the form), the film rests; it picks up again on return.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting;
        if (cinema) return;
        if (!inView && !video.paused) video.pause();
        else if (inView && !userPaused && video.paused) play();
      }, { threshold: 0.15 }).observe(video);
    }

    if (!userPaused) play();
    syncControls();
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && cinema) exitCinema();
  });

  /* ------------------------------------------------------------ sign-up */

  const setError = (message) => {
    if (!error || !input) return;
    error.textContent = message || '';
    if (message) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
  };

  const sending = (on) => {
    form.classList.toggle('is-sending', on);
    form.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  const showDone = () => {
    unlocked = true;
    root.setAttribute('data-state', 'done');
    if (idle) idle.hidden = true;
    if (done) done.hidden = false;
    if (sound) sound.hidden = false;
    if (video) video.loop = true;
    if (!reduceMotion.matches) root.classList.add('is-celebrating');
    say(label('done'));
    if (doneTitle) {
      doneTitle.focus({ preventScroll: true });
      const box = doneTitle.getBoundingClientRect();
      if (box.top < 0 || box.bottom > window.innerHeight) {
        doneTitle.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
    }
  };

  /* The post itself stays Shopify's. Its bot protection takes over every customer form on
     submit (an invisible hCaptcha, then a plain post), so a sign-up without a reload would be
     fighting it. This page only checks the address first — in the capture phase on window,
     ahead of Shopify's listener, so a typo never costs a round trip — then lets the post go.
     Shopify answers with ?customer_posted=true, the server renders the thank-you, and the
     surprise plays as the page comes back (below). */
  if (form && input) {
    input.addEventListener('input', () => { if (input.getAttribute('aria-invalid')) setError(''); });

    window.addEventListener('submit', (event) => {
      if (event.target !== form) return;
      input.value = input.value.trim();
      if (!input.value || !input.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setError(label('invalid'));
        input.focus();
        return;
      }
      setError('');
      sending(true);
      say(label('sending'));
    }, true);

    // Back from the next page through the cache: the form must not still be "sending".
    window.addEventListener('pageshow', (event) => { if (event.persisted) sending(false); });
  }

  if (unlocked) {
    showDone();
    // Shopify's answer carries ?customer_posted=true; drop it, so a reload is just a visit.
    if (/[?&]customer_posted=true/.test(window.location.search) && window.history.replaceState) {
      const clean = new URL(window.location.href);
      clean.searchParams.delete('customer_posted');
      ['contact[tags]', 'contact%5Btags%5D', 'form_type'].forEach((key) => clean.searchParams.delete(key));
      window.history.replaceState(null, '', clean.pathname + clean.search);
    }
  }

  /* ------------------------------------------------------------ the surprise */

  if (full && video) {
    full.addEventListener('click', () => {
      cinema = true;
      userPaused = false;
      root.classList.add('is-cinema');
      video.loop = false;
      video.currentTime = 0;
      video.muted = false;
      video.volume = 1;
      play();
      syncControls();
      const box = film.getBoundingClientRect();
      if (box.top < 0 || box.bottom > window.innerHeight) {
        film.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
    });
  }

  if (copy) {
    const code = $('[data-cs-code]');
    const original = copy.textContent;
    copy.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(code.textContent.trim());
        copy.textContent = label('copied');
        say(label('copied'));
        window.setTimeout(() => { copy.textContent = original; }, 2200);
      } catch (err) {
        const range = document.createRange();
        range.selectNodeContents(code);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    });
  }
})();
